export default "__VITE_ASSET__212b1afe__"